// src/constants/apiConfig.js
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isLocal = ['localhost', '127.0.0.1'].includes(hostname);
const productionApiUrl = 'https://epresensismkn1jombang.my.id/api/web';
const configuredApiUrl = process.env.REACT_APP_API_BASE_URL;
const tokenScope = 'student-web-v1';

// Tokens issued for the old iPhone API must not be reused with the dedicated
// web API scope. The next page load will send the user to login again.
if (typeof window !== 'undefined' && localStorage.getItem('auth_token_scope') !== tokenScope) {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_token_expires_at');
  localStorage.setItem('auth_token_scope', tokenScope);
}

export const ApiConfig = {
  // Saat development, request diarahkan ke Docker lokal. Build online tetap
  // memakai API HTTPS production.
  baseUrl: isLocal
    ? 'http://localhost:8082/api/web'
    : (configuredApiUrl || productionApiUrl),
  baseImageUrl: "https://epresensismkn1jombang.my.id",
  tokenScope,
};
